
export {Tooltip,
ClayTooltipProvider} from '@clayui/tooltip';
import __x__ from '@clayui/tooltip';export default __x__;